import React from 'react';
import { CheckCircle, Globe, Users, Award } from 'lucide-react';
import Logo from '../components/Logo';

const About = () => {
  const values = [
    {
      icon: CheckCircle,
      title: "Quality Assurance",
      description: "Rigorous testing and quality control for every shipment"
    },
    {
      icon: Globe,
      title: "Global Network",
      description: "Established partnerships across continents"
    },
    {
      icon: Users,
      title: "Expert Team",
      description: "Industry veterans with decades of combined experience"
    },
    {
      icon: Award,
      title: "Reliability",
      description: "98% on-time delivery rate with transparent tracking"
    }
  ];

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="page-hero">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginBottom: '24px', flexWrap: 'wrap' }}>
          <h1 className="display-huge" style={{ margin: 0 }}>About</h1>
          <Logo size="xlarge" />
        </div>
        <p className="body-large hero-description">
          Leading international bauxite trading company connecting Guinea's premium reserves with global aluminum producers.
        </p>
      </section>

      {/* Mission Section */}
      <section className="content-section">
        <div className="content-grid">
          <div className="content-text">
            <h2 className="display-medium">Our Mission</h2>
            <p className="body-medium">
              SpaceGems is dedicated to facilitating reliable and efficient bauxite trade between Guinea and major aluminum-producing regions across Asia, the Middle East, and Europe.
            </p>
            <p className="body-medium">
              With deep expertise in international commodities trading and established relationships with mining operations in Guinea, we ensure consistent supply of premium-grade bauxite to meet the exacting standards of modern aluminum smelters.
            </p>
          </div>
          <div className="content-text">
            <h2 className="display-medium">Our Approach</h2>
            <p className="body-medium">
              We combine technical expertise with logistical excellence to deliver comprehensive trading solutions. From quality assessment at the source to final delivery at smelter facilities, we manage every aspect of the supply chain.
            </p>
            <p className="body-medium">
              Our team includes geologists, logistics specialists, and commodities traders who work together to ensure seamless operations and customer satisfaction.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <h2 className="display-medium section-title">Our Values</h2>
        <div className="values-grid">
          {values.map((value, index) => {
            const IconComponent = value.icon;
            return (
              <div key={index} className="value-card">
                <div className="value-icon">
                  <IconComponent size={32} />
                </div>
                <h3 className="heading-2">{value.title}</h3>
                <p className="body-medium">{value.description}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* Experience Section */}
      <section className="experience-section">
        <div className="experience-content">
          <h2 className="display-medium">Industry Experience</h2>
          <div className="experience-stats">
            <div className="exp-stat">
              <div className="exp-number">900K+</div>
              <div className="exp-label">Tons Traded Annually</div>
            </div>
            <div className="exp-stat">
              <div className="exp-number">15+</div>
              <div className="exp-label">Countries Served</div>
            </div>
            <div className="exp-stat">
              <div className="exp-number">98%</div>
              <div className="exp-label">On-Time Delivery</div>
            </div>
          </div>
          <p className="body-large">
            Our track record speaks for itself. We've built lasting relationships with both suppliers and customers through consistent performance and transparent operations.
          </p>
        </div>
      </section>
    </div>
  );
};

export default About;